import { audioType } from '../cyberdice/interfaces'
import { useEffect } from 'react'
import useSound from 'use-sound'
import BackgroundSFX from '../lib/audio/backgroundSFX.mp3'
import WelcomeSFX from '../lib/audio/goodLuck.mp3'

export const handleBackgroundSFX = (
  audio: audioType,
  errorText: string | false,
  showLoader: boolean,
) => {
  const { music, isMusicOff } = audio
  const [playBackgroundSFX, { stop, sound }] = useSound(BackgroundSFX, {
    volume: parseFloat(music) / 100,
  })
  const [playWelcomeSFX] = useSound(WelcomeSFX, {
    volume: parseFloat(music) / 100,
  })

  useEffect(() => {
    !isMusicOff && !errorText && !showLoader
      ? (() => {
        playBackgroundSFX()
        sound && sound.loop(true)
      })()
      : stop()
  }, [isMusicOff, playBackgroundSFX, stop, sound, errorText, showLoader])

  useEffect(() => {
    !showLoader && playWelcomeSFX()
  }, [showLoader])
}

